import React, { useState } from 'react';
import { FiMonitor, FiTrash2, FiShoppingCart, FiCheckCircle } from 'react-icons/fi';

const PRODUCTS = [
  { id: 1, name: 'C.R.P. MASK', price: 250.00, category: 'Face', color: 'bg-blue-100 border-blue-300 text-blue-900' },
  { id: 2, name: 'WOW CURL CREAM', price: 100.00, category: 'Hair', color: 'bg-pink-100 border-pink-300 text-pink-900' },
  { id: 3, name: 'BOOSTER SERUM 25', price: 550.00, category: 'Face', color: 'bg-purple-100 border-purple-300 text-purple-900' }
];

export default function POS() {
  const [cart, setCart] = useState([]);

  const addToCart = (product) => {
    const existing = cart.find(item => item.id === product.id);
    if (existing) {
      setCart(cart.map(item => item.id === product.id ? { ...item, qty: item.qty + 1 } : item));
    } else {
      setCart([...cart, { ...product, qty: 1 }]);
    }
  };

  const removeFromCart = (id) => setCart(cart.filter(item => item.id !== id));
  
  const total = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);

  return (
    <div className="flex h-full bg-gray-100 font-sans">
      <div className="flex-1 p-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-max">
        {PRODUCTS.map(p => (
          <div key={p.id} onClick={() => addToCart(p)} className={`h-32 rounded-lg border-2 flex flex-col items-center justify-center cursor-pointer shadow-sm hover:shadow-md transition-shadow ${p.color}`}>
            <span className="font-bold text-center px-2">{p.name}</span>
            <span className="mt-2 text-lg">${p.price.toFixed(2)}</span>
          </div>
        ))}
      </div>
      <div className="w-96 bg-white border-l border-gray-200 flex flex-col shadow-xl z-10">
        <div className="p-4 bg-gray-800 text-white flex items-center justify-between">
          <div className="flex items-center"><FiMonitor className="mr-2" /> Current Order</div>
          <FiShoppingCart />
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">
          {cart.length === 0 ? (
            <div className="text-center text-gray-400 mt-10">Cart is empty</div>
          ) : (
            cart.map(item => (
              <div key={item.id} className="flex justify-between items-center bg-white p-3 rounded shadow-sm border border-gray-100">
                <div className="flex-1">
                  <div className="font-bold text-sm text-gray-800">{item.name}</div>
                  <div className="text-xs text-gray-500">{item.qty} x ${item.price.toFixed(2)}</div>
                </div>
                <div className="font-bold text-sm text-gray-800 mr-4">${(item.price * item.qty).toFixed(2)}</div>
                <FiTrash2 className="text-red-500 cursor-pointer hover:text-red-700" onClick={() => removeFromCart(item.id)} />
              </div>
            ))
          )}
        </div>
        <div className="p-4 bg-white border-t border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <span className="text-lg font-bold text-gray-600">Total</span>
            <span className="text-3xl font-black text-green-600">${total.toFixed(2)}</span>
          </div>
          <button onClick={() => setCart([])} disabled={cart.length === 0} className="w-full bg-green-600 text-white py-4 rounded-lg font-bold text-lg flex items-center justify-center hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <FiCheckCircle className="mr-2" /> Checkout
          </button>
        </div>
      </div>
    </div>
  );
}